import React, { useEffect, useState } from 'react';
import { calculateItemsWrapperWidthAndHeight } from '../utils';
import debounce from 'just-debounce';
import { TEST_ENV_WRAPPER_HEIGHT, TEST_ENV_WRAPPER_WIDTH } from '../constants';

interface IState {
  width: number;
  height: number;
}

export const useWrapperSize = (): [IState, React.Ref<HTMLElement>] => {
  const [wrapperSize, setWrapperSize] = useState<IState>({
    width: null,
    height: null,
  });

  const setWrapperWidthAndHeight = ({ width, height }) =>
    setWrapperSize({
      width: process.env.NODE_ENV === 'test' ? TEST_ENV_WRAPPER_WIDTH : width,
      height: process.env.NODE_ENV === 'test' ? TEST_ENV_WRAPPER_HEIGHT : height,
    });

  const [itemsWrapper, saveItemsWrapperRef] = useState<HTMLElement>(null);

  useEffect(() => {
    if (!itemsWrapper) {
      return;
    }

    setWrapperWidthAndHeight(calculateItemsWrapperWidthAndHeight(itemsWrapper));

    const resizeHandler = debounce(
      () => setWrapperWidthAndHeight(calculateItemsWrapperWidthAndHeight(itemsWrapper)),
      100,
    );

    window.addEventListener('resize', resizeHandler, false);

    return () => window.removeEventListener('resize', resizeHandler, false);
  }, [itemsWrapper]);

  return [wrapperSize, saveItemsWrapperRef];
};
